/* drawer-upsell.js - side cart only */
(function(){
  function getSectionIds(){
    var ids=[];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function(el){
      if(ids.indexOf(el.dataset.sectionId)===-1) ids.push(el.dataset.sectionId);
    });
    return ids;
  }

  function dispatchCartUpdate(data){
    document.dispatchEvent(new CustomEvent('cart:update',{
      bubbles:true,
      detail:{
        resource:data,
        sourceId:'drawer-upsell',
        data:{ sections:data.sections||{}, itemCount:data.item_count, source:'drawer-upsell' }
      }
    }));
  }

  function fmt(cents){
    var cur=(window.Shopify&&window.Shopify.currency&&window.Shopify.currency.active)||'EUR';
    try{ return new Intl.NumberFormat(navigator.language||'en',{style:'currency',currency:cur,minimumFractionDigits:2}).format(cents/100); }
    catch(_){ return (cents/100).toFixed(2); }
  }

  function resolveVariant(card){
    var el=card.querySelector('[data-du-variants]');
    if(!el) return null;
    var variants;
    try{ variants=JSON.parse(el.textContent); }catch(_){ return null; }
    if(!variants||!variants.length) return null;
    var selects=card.querySelectorAll('[data-du-select]');
    if(!selects.length) return variants[0];
    var chosen=[];
    selects.forEach(function(sel){ chosen[parseInt(sel.dataset.opt,10)]=sel.value; });
    return variants.find(function(v){
      return v.options.every(function(opt,i){ return opt===chosen[i]; });
    })||variants[0];
  }

  document.addEventListener('change',function(e){
    var sel=e.target.closest('[data-du-select]');
    if(!sel) return;
    var card=sel.closest('[data-du-card]');
    if(!card) return;
    var v=resolveVariant(card);
    if(!v) return;
    var el=card.querySelector('[data-du-price]');
    if(el) el.textContent=fmt(v.price);
  });

  document.addEventListener('click',function(e){
    var btn=e.target.closest('[data-du-btn]');
    if(!btn||btn.classList.contains('is-loading')) return;
    var card=btn.closest('[data-du-card]');
    if(!card) return;
    var v=resolveVariant(card);
    if(!v){ console.warn('[du] no variant'); return; }

    btn.classList.add('is-loading');
    var inCart=card.dataset.duInCart==='1';
    var sectionIds=getSectionIds();

    if(inCart){
      fetch('/cart/change.js',{
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({
          id:parseInt(card.dataset.duVariantId||v.id,10),
          quantity:0,
          sections:sectionIds,
          sections_url:window.location.pathname
        })
      }).then(function(r){return r.json();})
        .then(function(data){
          card.dataset.duInCart='0';
          card.dataset.duVariantId='';
          btn.classList.remove('is-added','is-loading');
          card.classList.remove('is-added');
          btn.querySelector('span').textContent='Add to cart';
          dispatchCartUpdate(data);
        }).catch(function(err){
          console.error('[du] remove',err);
          btn.classList.remove('is-loading');
        });
    } else {
      fetch('/cart/add.js',{
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({
          items:[{id:v.id,quantity:1}],
          sections:sectionIds,
          sections_url:window.location.pathname
        })
      }).then(function(r){return r.json();})
        .then(function(data){
          if(data.status&&data.status>=400){
            console.error('[du] add error',data.description||data.message);
            btn.classList.remove('is-loading');
            return;
          }
          card.dataset.duInCart='1';
          card.dataset.duVariantId=String(v.id);
          btn.classList.add('is-added');
          btn.classList.remove('is-loading');
          card.classList.add('is-added');
          btn.querySelector('span').textContent='Added';
          dispatchCartUpdate(data);
        }).catch(function(err){
          console.error('[du] add',err);
          btn.classList.remove('is-loading');
        });
    }
  });

})();
